import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import Button from 'components/field/Button';
import Icon from 'components/global/Icon';
import Image from 'components/global/Image';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalActions, ModalTitle } from 'components/global/styled/Modal.styled';

import useAlert from 'hooks/useAlert';
import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { Container, LogoContainer } from 'pages/SalesChannels/Stores/DeleteStore/DeleteStore.styled';

import { BRANCHES } from 'services/consts';

import AppLogger from 'utils/AppLogger';

import { faRotate } from '@fortawesome/pro-solid-svg-icons';

const schema = yup.object().shape({
	id: yup.number().nullable()
});

const SERVICES = {
	'foodics-delivery': BRANCHES.BRANCH_SYNC_FOODICS
};

const DELIVERY_COMPANY_ICONS = {
	'foodics-delivery': 'https://storage.googleapis.com/tryoto-public/sales-channels-logo/foodics-delivery.png'
};

const SynchronizeBranchModal = NiceModal.create(({ salesChannel }) => {
	const modal = useModal();
	const axiosPrivate = useAxiosPrivate();
	const { showError, showSuccess } = useAlert();
	const { t } = useTranslation();

	const formMethods = useForm({
		defaultValues: {
			id: salesChannel?.ID
		},
		resolver: yupResolver(schema)
	});

	const {
		handleSubmit,
		formState: { isSubmitting, isLoading: isFormLoading }
	} = formMethods;
	const isLoading = isSubmitting || isFormLoading;

	const onSubmit = async (data) => {
		try {
			const response = await axiosPrivate.post(SERVICES[salesChannel?.slug], {
				sccId: data.id.toString()
			});

			const res = response.data;
			if (res.success) {
				showSuccess();
				modal.remove();
			} else if (res.branchesMissingData && res.branchesMissingData.length > 0) {
				res.branchesMissingData.map((branch) => {
					showError({
						message: t('syncBranches.missingFields', {
							fields: branch.fields,
							branchName: branch.branchName
						})
					});
				});
			} else {
				showError();
			}
		} catch (error) {
			AppLogger.error(error);
			showError({
				message: error?.response?.data?.code || error?.response?.data?.message
			});
		}
	};

	return (
		<Modal maxWidth="small" fullwidth className="modal-synchronizeOrder">
			<ModalTitle>
				<Typography variant="p1">syncBranches</Typography>
			</ModalTitle>
			<Container>
				<LogoContainer>
					<Image width="6rem" height="6rem" url={salesChannel?.icon} />
					<Icon icon={faRotate} fontSize="3rem" />
					<Image width="6rem" height="6rem" url={DELIVERY_COMPANY_ICONS[salesChannel?.slug]} />
				</LogoContainer>
				<Typography variant="p3" color="var(--content-2)" noWrap align="center">
					{t('brancSyncSubtitle', {
						channelName: t(`salesChannel.${salesChannel?.integrationName}`)
					})}
				</Typography>
			</Container>
			<ModalActions>
				<Button label="cancel" onClick={() => modal.remove()} variant="outline" />
				<Button
					onClick={handleSubmit(onSubmit, AppLogger.log)}
					icon={faRotate}
					label="synchronize"
					variant="blue"
					loading={isLoading}
				/>
			</ModalActions>
		</Modal>
	);
});

export default SynchronizeBranchModal;
